<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="3.5" fill="#141411" />
    <rect x="3" y="4" width="1.45" height="8" rx="0.725" fill="#F6F1E8" />
    <rect x="5.15" y="3" width="1.45" height="10" rx="0.725" fill="#F6F1E8" />
    <rect x="7.3" y="2.5" width="1.45" height="11" rx="0.725" fill="#F6F1E8" />
    <rect x="9.45" y="3" width="1.45" height="10" rx="0.725" fill="#F6F1E8" />
    <rect x="11.6" y="4" width="1.45" height="8" rx="0.725" fill="#F6F1E8" />
  </svg>
</template>
